import "./property-info4.css";
import React, { Suspense, useState, useEffect } from "react";
import { loadUser } from "../../actions/authActions";
import { getPropertyList, applyProperty } from "../../actions/propertyAction";

import {
  unlikeProperty,
  likeProperty,
  hiddenProperty,
  reportProperty,
} from "../../actions/propertyAction";
import {
  Fix_value,
  Fix_value_id,
  settings,
  silderData,
  home_appliances,
  restrictions_val,
  home_appliances_id,
  restrictions_val_id,
  images,
} from "./propertyArray";
import moment from "moment";
import DayJS from "react-dayjs";
import Modal from "@mui/material/Modal";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import Box from "@mui/material/Box";
// import Button from '@mui/material/Button';
import Typography from "@mui/material/Typography";

import _, { set } from "lodash";

import {
  getPropertyDetail,
  PrintPropertyDetail,
  getPropertyDetailOwner,
} from "../../actions/propertyAction";
import { connect, useSelector } from "react-redux";
import Slider from "react-slick";
import { Link, useHistory, useParams, Redirect } from "react-router-dom";

import { Button, Form, FormGroup, Label, Input, FormText } from "reactstrap";
import { BsFacebook } from "react-icons/bs";
import Loading from "../../components/Loading";
import LoggedHeader from "../../DefaultLayout/LoggedHeader";
import Footer from "../../DefaultLayout/Footer";
import NavbarSection from "../../DefaultLayout/Navbar";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";

import ImageGallery from "react-image-gallery";
// Import Swiper styles
// import 'swiper/css'
// import 'swiper/css/free-mode'
// import 'swiper/css/navigation'
// import 'swiper/css/thumbs'
import "./swiper.css";
import "./swiper1.scss";
import { AccordionDetails } from "@mui/material";
import Header from "../../DefaultLayout/Header";
import { toast } from "react-toastify";
import { addChat } from "../../actions/firebaseAction";
import MapComponentDetail from "../../components/GoogleMapDetail";
import swal from "sweetalert";
import { dropdownPropertyField } from "../../actions/propertyFieldAction.js";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "react-lazy-load-image-component/src/effects/opacity.css";
import DashboardNavbar from "../../DefaultLayout/DashboardNavbar.js";

let rowsPerPage = 12;
const BrokenImage = "assets/no-picture-available-icon-1.jpg";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 824,
  height: "460px !important",
};

const PropertyPreview = (props) => {
  const history = useHistory();

  const {
    allData,
    getPropertyList,
    getPropertyDetail,
    applyProperty,
    auth,
    label,
  } = props;
  const { frontLabelsName } = label;
  const isAuth = auth.isAuthenticated;
  // console.log(isAuth);
  // const subscription_status = auth.user.subscription_status;
  const subscriptions = useSelector((state) => state.subscription);
  const lng = localStorage.getItem("prevLangFront") ;
  const userName = auth.user;
  const [DataImg, setDataImg] = useState([]);
  const { id, req } = useParams();
  let { slug } = useParams();

  const [detailData, setDetailData] = useState();
  const [applyModal, setApplyModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [openApplyBox, setOpenApplyBox] = useState(false);
  const [applyBoxData, setApplyBoxData] = useState("");
  const [sliderImg, setsliderImg] = useState();
  const [thumbsSwiper, setThumbsSwiper] = useState();
  const [applyHouse, setapplyHouse] = useState();
  const [mapLoading, setMapLoading] = useState(false);
  const [pdf, setPdf] = useState("");
  const properties = useSelector((state) => state.properties);
  const { property, propertyLoading } = properties;
  const [propertyInclude, setPropertyInclude] = useState([]);
  const [propertyHome, setPropertyHome] = useState([]);
  const [propertyRestriction, setPropertyRestriction] = useState([]);

  const [includedType, setIncludedType] = useState([]);
  const [homeApplianceType, setHomeApplianceType] = useState([]);
  const [restrictionsType, setRestrictionsType] = useState([]);
  const [accessType, setAccessType] = useState([]);
  const [otherType, setOtherType] = useState([]);

  const [match, setMatch] = useState([]);
  const token = localStorage.getItem("ownerAppToken")
    ? localStorage.getItem("ownerAppToken")
    : localStorage.getItem("AdminAppToken");
  //   console.log(token,'token');

  useEffect(() => {
    window.scrollTo(0, 0);
    setMapLoading(true);
    getPropertyList(
      1,
      20,
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      ""
    );
    if (req === "request") {
      props.getPropertyDetailOwner(id, token, true).then((res) => {
        setMapLoading(false);
        setDetailData(res);
        setPropertyInclude(res?.included);
        setPropertyHome(res?.homeAppliances);
        setPropertyRestriction(res?.restrictions);
      });
    } else {
      props.getPropertyDetailOwner(id, token, false).then((res) => {
        setMapLoading(false);
        setDetailData(res);
        setPropertyInclude(res?.included);
        setPropertyHome(res?.homeAppliances);
        setPropertyRestriction(res?.restrictions);
      });
    }
  }, [id]);

  useEffect(() => {
    props.dropdownPropertyField("").then((res) => {
      // console.log(res.type_2,'res')
      setIncludedType(res?.type_1);
      setHomeApplianceType(res?.type_2);
      setRestrictionsType(res?.type_3);
      setAccessType(res?.type4);
      setOtherType(res?.type5);
    });
  }, []);

  // if (token == null || token == undefined || token == "") {
  //   swal({
  //     title: frontLabelsName
  //       ? frontLabelsName.filter((e) => e.key == "lbl_please_login").length > 0
  //         ? frontLabelsName.filter((e) => e.key == "lbl_please_login")[0]["value"] ||
  //         "lbl_please_login"
  //         : "lbl_please_login"
  //       : "lbl_please_login",
  //     text: frontLabelsName
  //       ? frontLabelsName.filter((e) => e.key == "lbl_login_view_properties")
  //         .length > 0
  //         ? frontLabelsName.filter((e) => e.key == "lbl_login_view_properties")[0][
  //         "value"
  //         ] || "lbl_login_view_properties"
  //         : "lbl_login_view_properties"
  //       : "lbl_login_view_properties",
  //     icon: "info",
  //     // buttons: true,
  //     dangerMode: true,
  //   }).then((willDelete) => {
  //     if (willDelete) {
  //     }
  //   });
  //   return <Redirect to={"/login"} />;
  // }
  // console.log(propertyInclude,'propertyInclude',propertyHome)
  // apply for property

  const loginCheck = async (data) => {
    // e.preventDefault()
    if (auth.isAuthenticated) {
      // const data = {
      //   property: id,
      // }
      // const res = await applyProperty(data)
      // setApplyModal(false)
      // getPropertyDetail(id).then((res) => {
      //   setDetailData(res)
      // })
      // console.log(data, "data1");
      setApplyBoxData(data);
      setOpenApplyBox(true);
    } else {
      toast.error(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == "lbl_please_login_to_access")
            .length > 0
            ? frontLabelsName.filter(
              (e) => e.key == "lbl_please_login_to_access"
            )[0]["value"] || "lbl_please_login_to_access"
            : "lbl_please_login_to_access"
          : "lbl_please_login_to_access"
      );
    }
  };
  // console.log(applyBoxData, "applyBoxData");
  // end here apply for property

  // Toggle for Modal
  const applyToggle = () => setApplyModal(true);

  const handleApplyModal = (e) => {
    e.preventDefault();
    setApplyModal(false);
    setOpenApplyBox(false);
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };
  const apidatimg = detailData?.photo_gallery;

  const handleClose = () => setOpen(false);

  // please dont change code becoz we are mange.
  let right = _.differenceBy(Fix_value_id, detailData?.included);
  let righthomeapp = _.differenceBy(
    home_appliances_id,
    detailData?.homeAppliances
  );

  let rightrestrictions = _.differenceBy(
    restrictions_val_id,
    detailData?.restrictions
  );

  const imgSlider_Model = detailData?.photo_gallery.map((val) => {
    return {
      original: val,
      thumbnail: val,
    };
  });

  // like or unlike code start here

  const like = async (e) => {
    e.preventDefault();
    if (auth.isAuthenticated) {
      let newAddLike = {
        property_id: detailData?._id,
      };
      const res = await props.likeProperty(newAddLike).then((ress) => {
        toast.success(
          frontLabelsName
            ? frontLabelsName.filter((e) => e.key == ress.data.message).length > 0
              ? frontLabelsName.filter((e) => e.key == ress.data.message)[0][
              "value"
              ] || ress.data.message
              : ress.data.message
            : ress.data.message
        );
        getPropertyDetail(id).then((res) => {
          setDetailData(res);
        });
      });
    } else {
      toast.error(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == "lbl_please_login_to_access")
            .length > 0
            ? frontLabelsName.filter(
              (e) => e.key == "lbl_please_login_to_access"
            )[0]["value"] || "lbl_please_login_to_access"
            : "lbl_please_login_to_access"
          : "lbl_please_login_to_access"
      );
    }
  };

  // end here like and unlike

  // unlike funtion start here

  const unlike = async (e) => {
    e.preventDefault();
    if (auth.isAuthenticated) {
      const res = await props.unlikeProperty(detailData?._id).then((ress) => {
        toast.success(
          frontLabelsName
            ? frontLabelsName.filter((e) => e.key == ress.message).length > 0
              ? frontLabelsName.filter((e) => e.key == ress.message)[0]["value"] ||
              ress.message
              : ress.message
            : ress.message
        );
        getPropertyDetail(id).then((res) => {
          setDetailData(res);
        });
      });
    } else {
      toast.error(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == "lbl_please_login_to_access")
            .length > 0
            ? frontLabelsName.filter(
              (e) => e.key == "lbl_please_login_to_access"
            )[0]["value"] || "lbl_please_login_to_access"
            : "lbl_please_login_to_access"
          : "lbl_please_login_to_access"
      );
    }
  };

  // end here unlike

  // hidden property start here

  const hidden = async (e) => {
    // console.log("resonse propery", property_id);
    e.preventDefault();
    if (auth.isAuthenticated) {
      let newhidden = {
        property_id: detailData?._id,
      };
      const res = props.hiddenProperty(newhidden).then((ress) => {
        toast.success(
          frontLabelsName
            ? frontLabelsName.filter((e) => e.key == ress.data.message).length > 0
              ? frontLabelsName.filter((e) => e.key == ress.data.message)[0][
              "value"
              ] || ress.data.message
              : ress.data.message
            : ress.data.message
        );
        getPropertyDetail(id).then((res) => {
          setDetailData(res);
        });
        history.push("/properties");
      });
    } else {
      toast.error(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == "lbl_please_login_to_access")
            .length > 0
            ? frontLabelsName.filter(
              (e) => e.key == "lbl_please_login_to_access"
            )[0]["value"] || "lbl_please_login_to_access"
            : "lbl_please_login_to_access"
          : "lbl_please_login_to_access"
      );
    }
  };

  // print
  const HandlePrint = (e) => {
    e.preventDefault();
    if (auth.isAuthenticated) {
      props.PrintPropertyDetail(id).then((res) => {
        window.open(res, "_blank");
        setPdf(res);
      });
    } else {
      toast.error(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == "lbl_please_login_to_access")
            .length > 0
            ? frontLabelsName.filter(
              (e) => e.key == "lbl_please_login_to_access"
            )[0]["value"] || "lbl_please_login_to_access"
            : "lbl_please_login_to_access"
          : "lbl_please_login_to_access"
      );
    }
  };

  // report details

  const reportdetails = async (e, property_id) => {
    // console.log("report propertyid", property_id);
    e.preventDefault();
    if (auth.isAuthenticated) {
      history.push(`/report-property/${property_id}`);
      // const newreport = {
      //   property_id: property_id,
      // };
      // const res = await props.reportProperty(newreport).then((Response) => {
      //   getPropertyDetail(id).then((res) => {
      //     setDetailData(res);
      //   });
      // });
    } else {
      toast.error(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == "lbl_please_login_to_access")
            .length > 0
            ? frontLabelsName.filter(
              (e) => e.key == "lbl_please_login_to_access"
            )[0]["value"] || "lbl_please_login_to_access"
            : "lbl_please_login_to_access"
          : "lbl_please_login_to_access"
      );
    }
  };

  const getTypeName = (val) => {
    if (val === "detachedHouse") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_detached_house").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_detached_house")[0][
          "value"
          ] || "lbl_detached_house"
          : "lbl_detached_house"
        : "lbl_detached_house";
    } else if (val === "duplex") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_duplex").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_duplex")[0]["value"] ||
          "lbl_duplex"
          : "lbl_duplex"
        : "lbl_duplex";
    } else if (val === "tripleAptHouse") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_triple_apt_house").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_triple_apt_house")[0][
          "value"
          ] || "lbl_triple_apt_house"
          : "lbl_triple_apt_house"
        : "lbl_triple_apt_house";
    } else if (val === "aptBulding") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_apt_building").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_apt_building")[0]["value"] ||
          "lbl_apt_building"
          : "lbl_apt_building"
        : "lbl_apt_building";
    } else if (val === "townhouseTwin") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_townhouse_twin").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_townhouse_twin")[0][
          "value"
          ] || "lbl_townhouse_twin"
          : "lbl_townhouse_twin"
        : "lbl_townhouse_twin";
    } else if (val === "garage") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_garage").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_garage")[0]["value"] ||
          "lbl_garage"
          : "lbl_garage"
        : "lbl_garage";
    } else if (val === "summerHouse") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_summer_house").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_summer_house")[0]["value"] ||
          "lbl_summer_house"
          : "lbl_summer_house"
        : "lbl_summer_house";
    } else if (val === "cotenant") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_co_tenant").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_co_tenant")[0]["value"] ||
          "lbl_co_tenant"
          : "lbl_co_tenant"
        : "lbl_co_tenant";
    } else if (val === "hotelGesthouse") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_hotel_guest_house").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_hotel_guest_house")[0][
          "value"
          ] || "lbl_hotel_guest_house"
          : "lbl_hotel_guest_house"
        : "lbl_hotel_guest_house";
    }
  };

  const handleAddChat = () => {
    if (auth.isAuthenticated) {
      const data = {
        property: detailData._id,
        owner: detailData?.posted_by?._id,
        user: auth?.user?._id,
      };
      props.addChat(data).then((res) => {
        history.push({
          pathname: `/chat-view/${res.data?.result?._id}`,
          state: { data: res.data?.result?._id },
        });
      });
    } else {
      toast.error(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == "lbl_please_login_to_access")
            .length > 0
            ? frontLabelsName.filter(
              (e) => e.key == "lbl_please_login_to_access"
            )[0]["value"] || "lbl_please_login_to_access"
            : "lbl_please_login_to_access"
          : "lbl_please_login_to_access"
      );
    }
  };

  const mapProperty = (e) => {
    e.preventDefault();
    if (auth.isAuthenticated) {
      history.push("/properties-map");
    } else {
      toast.error(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == "lbl_please_login_to_access")
            .length > 0
            ? frontLabelsName.filter(
              (e) => e.key == "lbl_please_login_to_access"
            )[0]["value"] || "lbl_please_login_to_access"
            : "lbl_please_login_to_access"
          : "lbl_please_login_to_access"
      );
    }
  };

  const applyModelProperty = async (e) => {
    e.preventDefault();
    const data = {
      property: id,
    };
    const res = await applyProperty(data).then((ress) => {
      toast.success(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == ress.message).length > 0
            ? frontLabelsName.filter((e) => e.key == ress.message)[0]["value"] ||
            ress.message
            : ress.message
          : ress.message
      );
    });
    setApplyModal(false);
    getPropertyDetail(id).then((res) => {
      setDetailData(res);
    });
    setOpenApplyBox(false);
  };

  const includs = (filedData, newData) => {

    let result = filedData.filter(function (obj) {
      return newData.some(function (val) {
        return val === obj._id;
      });
    });

    return result.map((d) => {
      return (
        <>
          <div className="setting-links1">
            <p>
              <a>
                <span className="d-flex cus-space1">
                  <img src="assets/tick.svg" />
                  {Array.isArray(d?.name) ? d?.name?.filter((e)=>(  (e[lng])))[0][lng]['name']:d?.name }
                </span>
              </a>
            </p>
          </div>
        </>
      );
    });
 
  };

  const includs1 = (filedData, newData) => {
   
    let result = filedData.filter((elm) => !newData.includes(elm._id));
  
    return result.map((d) => {
      return (
        <>
          <div className="setting-links1">
            <p>
              <a>
                <span className="d-flex cus-space1">
                  <img src="assets/cross.svg" />
                  {Array.isArray(d?.name) ? d?.name?.filter((e)=>(  (e[lng])))[0][lng]['name']:d?.name }
                </span>
              </a>
            </p>
          </div>
        </>
      );
    });

  };

  const includs2 = (filedData) => {

    return filedData.map((d) => {
      return (
        <>
          <div className="setting-links1">
            <p>
              <a>
                <span className="d-flex cus-space1">
                  <img src="assets/cross.svg" />
                  {Array.isArray(d?.name) ? d?.name?.filter((e)=>(  (e[lng])))[0][lng]['name']:d?.name }
                </span>
              </a>
            </p>
          </div>
        </>
      );
    });
  };

  const imageNotFound = (event) => {
    event.currentTarget.src = BrokenImage;
  };

 

  const getAvailabilityMultilanguage = (value) => {
    if (value === "Before Noon") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_before_noon").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_before_noon")[0]["value"] ||
          "lbl_before_noon"
          : "lbl_before_noon"
        : "lbl_before_noon";
    } else if (value === "After Noon") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_after_noon").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_after_noon")[0]["value"] ||
          "lbl_after_noon"
          : "lbl_after_noon"
        : "lbl_after_noon";
    } else {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_all_day").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_all_day")[0]["value"] ||
          "lbl_all_day"
          : "lbl_all_day"
        : "lbl_all_day";
    }
  };

  return (
    <React.Fragment>
      <Suspense fallback={<Loading />}>
        {isAuth ? <LoggedHeader /> : <Header />}
 
        <DashboardNavbar />
      </Suspense>

      <div className="div-wrapper">
        <div className="row">
          <div className="links-main1 d-flex col-lg-12 mb-2">
           
          </div>
        </div>
        <div className="row row_style">
          <div className="col-lg-8 col-md-12">
            <div className="links-main1 d-flex col-lg-12 col-md-12 mb-3">
              <p>
                {frontLabelsName
                  ? frontLabelsName.filter((e) => e.key == "lbl_property_was_listed")
                    .length > 0
                    ? frontLabelsName.filter(
                      (e) => e.key == "lbl_property_was_listed"
                    )[0]["value"] || "lbl_property_was_listed"
                    : "lbl_property_was_listed"
                  : "lbl_property_was_listed"}{" "}
                :{" "}
                <span>{moment(detailData?.createdAt).format("DD/MM/yyyy")}</span>
              </p>
              <p>
                {frontLabelsName
                  ? frontLabelsName.filter((e) => e.key == "lbl_last_modified")
                    .length > 0
                    ? frontLabelsName.filter((e) => e.key == "lbl_last_modified")[0][
                    "value"
                    ] || "lbl_last_modified"
                    : "lbl_last_modified"
                  : "lbl_last_modified"}{" "}
                :{" "}
                <span>{moment(detailData?.updatedAt).format("DD/MM/yyyy")}</span>
              </p>
              <p>
                {frontLabelsName
                  ? frontLabelsName.filter((e) => e.key == "lbl_property_viewed")
                    .length > 0
                    ? frontLabelsName.filter((e) => e.key == "lbl_property_viewed")[0][
                    "value"
                    ] || "lbl_property_viewed"
                    : "lbl_property_viewed"
                  : "lbl_property_viewed"}{" "}
                : <span>{detailData?.views}</span>
              </p>
              <p>
                {frontLabelsName
                  ? frontLabelsName.filter((e) => e.key == "lbl_no_of_photos").length >
                    0
                    ? frontLabelsName.filter((e) => e.key == "lbl_no_of_photos")[0][
                    "value"
                    ] || "lbl_no_of_photos"
                    : "lbl_no_of_photos"
                  : "lbl_no_of_photos"}{" "}
                : <span>{detailData?.photo_gallery.length}</span>
              </p>
              {detailData?.unique_No && (
                <p>
                  {frontLabelsName
                    ? frontLabelsName.filter((e) => e.key == "lbl_unique_per_no")
                      .length > 0
                      ? frontLabelsName.filter((e) => e.key == "lbl_unique_per_no")[0][
                      "value"
                      ] || "lbl_unique_per_no"
                      : "lbl_unique_per_no"
                    : "lbl_unique_per_no"}{" "}
                  : <span>{detailData?.unique_No}</span>
                </p>
              )}
              
             
              {detailData?.wholeProperty=="detachedHouse" && (
                <p>
                  {frontLabelsName
                    ? frontLabelsName.filter((e) => e.key == "lbl_whole_property_part")
                      .length > 0
                      ? frontLabelsName.filter(
                        (e) => e.key == "lbl_whole_property_part"
                      )[0]["value"] || "lbl_whole_property_part"
                      : "lbl_whole_property_part"
                    : "lbl_whole_property_part"}{" "}
                  :{" "}
                  <span>
                    {detailData?.wholeProperty === "yes"
                      ? frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_yes").length > 0
                          ? frontLabelsName.filter((e) => e.key == "lbl_yes")[0][
                          "value"
                          ] || "lbl_yes"
                          : "lbl_yes"
                        : "lbl_yes"
                      : ""}
                    {detailData?.wholeProperty === "no"
                      ? frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_no").length > 0
                          ? frontLabelsName.filter((e) => e.key == "lbl_no")[0][
                          "value"
                          ] || "lbl_no"
                          : "lbl_no"
                        : "lbl_no"
                      : ""}
                  </span>
                </p>
              )}
            </div>
            <div className="view-port-main1">
              <div className="view-card-main1">
                <div className="img-view-main1">
              
                  <LazyLoadImage
                    alt="cover_photo"
                    height="100%"
                    src={
                      detailData?.cover_photo
                        ? detailData?.cover_photo
                        : detailData?.photo_gallery[0]
                    } // use normal <img> attributes as props
                    width="100%"
                    effect="blur"
                    placeholderSrc={detailData?.cover_photo}
                    onError={imageNotFound}
                  />
                </div>
                <div className="overlayblack-card-info1">
                  <div className="set-overlay1 ">
                    <p>{detailData?.location?detailData?.location:""}</p>
                  
                  </div>
                  <div className="bottom-desc1">
                    <p className="mb-0">
                      {detailData?.area ? detailData?.area :""}
                    </p>
                    <div>
                      <p className="mb-2"> {`${detailData?.propertyType ? getTypeName(detailData?.propertyType) :""}, ${
                                detailData?.bhk === "Storage"
                                  ? frontLabelsName
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_storage"
                                      ).length > 0
                                      ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_storage"
                                        )[0]["value"] || "lbl_storage"
                                      : "lbl_storage"
                                    : "lbl_storage"
                                  : detailData?.bhk === "Single Room"
                                  ? frontLabelsName
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_single_room"
                                      ).length > 0
                                      ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_single_room"
                                        )[0]["value"] || "lbl_single_room"
                                      : "lbl_single_room"
                                    : "lbl_single_room"
                                  : detailData?.bhk === "Studio"
                                  ? frontLabelsName
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_studio"
                                      ).length > 0
                                      ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_studio"
                                        )[0]["value"] || "lbl_studio"
                                      : "lbl_studio"
                                    : "lbl_studio"
                                  : `${detailData?.bhk ? detailData?.bhk :""} ${
                                      frontLabelsName
                                        ? frontLabelsName.filter(
                                            (e) => e.key == "lbl_rooms"
                                          ).length > 0
                                          ? frontLabelsName.filter(
                                              (e) => e.key == "lbl_rooms"
                                            )[0]["value"] || "lbl_rooms"
                                          : "lbl_rooms"
                                        : "lbl_rooms"
                                    }`
                              }, ${detailData?.size ? detailData?.size:""} ㎡, ${detailData?.availability === "true"
                                ? frontLabelsName
                                  ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_available_right_away"
                                  ).length > 0
                                    ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_available_right_away"
                                    )[0]["value"] || "lbl_available_right_away"
                                    : "lbl_available_right_away"
                                  : "lbl_available_right_away"
                                :detailData?.availabilityDate ?moment(detailData?.availabilityDate).format(
                                                            "DD/MM/yyyy"
                                                          ): null}, ${detailData?.deliveryRightAway === true
                                  ? frontLabelsName
                                    ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_long_term"
                                    ).length > 0
                                      ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_long_term"
                                      )[0]["value"] || "lbl_long_term"
                                      : "lbl_long_term"
                                    : "lbl_long_term"
                                  :detailData?.deliveryDate ? moment(detailData?.deliveryDate).format(
                                                                "DD/MM/yyyy"
                                                              ): null}`}</p>
                    </div>
                  </div>
                </div>
                {detailData?.photo_gallery?.length > 0 && (
                  <div className="btn-all-photo1">
                    <button onClick={handleOpen}>
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_all_photos")
                          .length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_all_photos"
                          )[0]["value"] || "lbl_all_photos"
                          : "lbl_all_photos"
                        : "lbl_all_photos"}
                    </button>
                  </div>
                )}
              </div>
            </div>
            <div className="set-bottom-btn-white1 d-flex">
              <div className="set-pdd-set-all1">
                {detailData?.favourite === 0 ? (
                  <p onClick={(e) => like(e, detailData?._id)}  style={{minWidth:"max-content"}}  className="favourite-p">
                    <img src="assets/unfav.svg" alt="Favorites" />
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_favourite")
                        .length > 0
                        ? frontLabelsName.filter((e) => e.key == "lbl_favourite")[0][
                        "value"
                        ] || "lbl_favourite"
                        : "lbl_favourite"
                      : "lbl_favourite"}
                  </p>
                ) : (
                  <p onClick={(e) => unlike(e, detailData?._id)}  style={{minWidth:"max-content"}}  className="favourite-p">
                    <img src="assets/like.svg" alt="Favorites" />
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_favourite")
                        .length > 0
                        ? frontLabelsName.filter((e) => e.key == "lbl_favourite")[0][
                        "value"
                        ] || "lbl_favourite"
                        : "lbl_favourite"
                      : "lbl_favourite"}
                  </p>
                )}
              </div>
              <div className="set-pdd-set-all1">
                <p onClick={(e) => hidden(e, detailData?._id)}  className="favourite-p">
                  <img src="assets/icons/hideicon.svg" alt="Hide" />
                  {frontLabelsName
                    ? frontLabelsName.filter((e) => e.key == "lbl_hide").length > 0
                      ? frontLabelsName.filter((e) => e.key == "lbl_hide")[0][
                      "value"
                      ] || "lbl_hide"
                      : "lbl_hide"
                    : "lbl_hide"}
                </p>
              </div>
              <div className="set-pdd-set-all1">
                <p  className="favourite-p">
                  <Link
                    to={{
                      pathname: "/properties-map",
                      state: { user: detailData },
                    }}
                    style={{
                      color: "black",
                      textDecoration: "none",
                    }}
                  >
                    <img src="assets/map222.svg" alt="Map" />
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_map").length > 0
                        ? frontLabelsName.filter((e) => e.key == "lbl_map")[0][
                        "value"
                        ] || "lbl_map"
                        : "lbl_map"
                      : "lbl_map"}
                  </Link>
                </p>
              </div>
              <div className="set-pdd-set-all1">
                <p onClick={(e) => HandlePrint(e)}  className="favourite-p">
                  <a>
                    <img src="assets/print.svg" alt="Print" />
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_print").length >
                        0
                        ? frontLabelsName.filter((e) => e.key == "lbl_print")[0][
                        "value"
                        ] || "lbl_print"
                        : "lbl_print"
                      : "lbl_print"}
                  </a>
                </p>
              </div>
              <div className="set-pdd-set-all1">
                <p onClick={handleAddChat}  className="favourite-p">
              
                  <img src="assets/message.svg" alt="Message" />
                  {frontLabelsName
                    ? frontLabelsName.filter((e) => e.key == "lbl_message").length >
                      0
                      ? frontLabelsName.filter((e) => e.key == "lbl_message")[0][
                      "value"
                      ] || "lbl_message"
                      : "lbl_message"
                    : "lbl_message"}
          
                </p>
              </div>

              <div className="set-pdd-set-all1 btn-apply-property1">
                {detailData?.applied === 0 ? (
                  <p onClick={() => loginCheck(detailData)}  className="favourite-p">
                    <a className="d-flex justify-content-center align-items-center">
                      <img src="assets/icons/applyproperty.svg" alt="Message" />
                      <span>
                        {frontLabelsName
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_apply_property"
                          ).length > 0
                            ? frontLabelsName.filter(
                              (e) => e.key == "lbl_apply_property"
                            )[0]["value"] || "lbl_apply_property"
                            : "lbl_apply_property"
                          : "lbl_apply_property"}
                      </span>
                    </a>
                  </p>
                ) : (
                  <p  className="favourite-p">
                    <a className="d-flex justify-content-center align-items-center disable-links">
                      <img src="assets/icons/applyproperty.svg" alt="Message" />
                      <span>
                        {frontLabelsName
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_already_applied"
                          ).length > 0
                            ? frontLabelsName.filter(
                              (e) => e.key == "lbl_already_applied"
                            )[0]["value"] || "lbl_already_applied"
                            : "lbl_already_applied"
                          : "lbl_already_applied"}
                      </span>
                    </a>
                  </p>
                )}
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-12">
            <div className="right-menu-bar-fill2">
              <div className="first-rent-desc">

                <div className="">
                

                  {/* Rental price */}
                  <div className="rental-price d-flex justify-content-between align-items-center">
                    <h3 className="">
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_rental_price")
                          .length > 0
                          ? frontLabelsName.filter((e) => e.key == "lbl_rental_price")[0][
                          "value"
                          ] || "lbl_rental_price"
                          : "lbl_rental_price"
                        : "lbl_rental_price"}:{" "}
                    </h3>
                    <h3 className="">
                      {detailData?.propertyPrice}{" "}
                  
                      Kr.{" "}
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_per_month")
                          .length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_per_month"
                          )[0]["value"] || "lbl_per_month"
                          : "lbl_per_month"
                        : "lbl_per_month"}
                     
                    </h3>
                  </div>
                </div>

              </div>

              <div className="desc-pri-set4 pt-3 d-flex align-items-center">
                

                {  
                  <div className="col-12 d-flex justify-content-between pb-0">
                    <h3 className="">
                      {frontLabelsName
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_power"
                        ).length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_power"
                          )[0]["value"] || "lbl_power"
                          : "lbl_power"
                        : "lbl_power"}:
                    </h3>
                    <h3 className="">
                  
                      {detailData?.powerPrice ? detailData?.powerPrice  : "0" }
                     { " " + "-" + " "}
                      { detailData?.powerPrice ? frontLabelsName
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_intended_for"
                        ).length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_intended_for"
                          )[0]["value"] || "lbl_intended_for"
                          : "lbl_intended_for"
                        : "lbl_intended_for" : 
                        
                        frontLabelsName
                        ?
                        frontLabelsName.filter(
                          (e) => e.key == "lbl_included"
                        ).length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_included"
                          )[0]["value"] || "lbl_included"
                          : "lbl_included"
                        : "lbl_included"
                        }
                    </h3>
                  </div>
                }

                

                {
                  <div className="col-12 d-flex justify-content-between pb-0">
                    <h3 className="">
                      {frontLabelsName
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_hiti"
                        ).length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_hiti"
                          )[0]["value"] || "lbl_hiti"
                          : "lbl_hiti"
                        : "lbl_hiti"}:
                    </h3>
                    <h3 className="">
                    
                      {detailData?.hitiPrice  ? detailData?.hitiPrice + " " + "-" + " "  : 0+ " " + "-" + " "}
                
                         {detailData?.hitiPrice  ?
                       frontLabelsName
                       ? frontLabelsName.filter(
                         (e) => e.key == "lbl_intended_for"
                       ).length > 0
                         ? frontLabelsName.filter(
                           (e) => e.key == "lbl_intended_for"
                         )[0]["value"] || "lbl_intended_for"
                         : "lbl_intended_for"
                       : "lbl_intended_for"
                        :
                        frontLabelsName
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_included"
                          ).length > 0
                            ? frontLabelsName.filter(
                              (e) => e.key == "lbl_included"
                            )[0]["value"] || "lbl_included"
                            : "lbl_included"
                          : "lbl_included"
                      } 
                    </h3>
                  </div>
                }


                {
                  <div className="col-12 d-flex justify-content-between pb-2">
                    <h3 className="">
                      {frontLabelsName
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_house_fund"
                        ).length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_house_fund"
                          )[0]["value"] || "lbl_house_fund"
                          : "lbl_house_fund"
                        : "lbl_house_fund"}:
                    </h3>
                    <h3 className="">
                    {detailData?.dummy_deposit !=="none" ? detailData?.houseFund ? detailData?.houseFund : "0"+ " " + "-" + " " :""}
                      {detailData?.dummy_deposit !=="none" ? detailData?.houseFund  ?
                       ""
                        :
                        frontLabelsName
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_included"
                          ).length > 0
                            ? frontLabelsName.filter(
                              (e) => e.key == "lbl_included"
                            )[0]["value"] || "lbl_included"
                            : "lbl_included"
                          : "lbl_included":
                          frontLabelsName
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_none"
                          ).length > 0
                            ? frontLabelsName.filter(
                              (e) => e.key == "lbl_none"
                            )[0]["value"] || "lbl_none"
                            : "lbl_none"
                          : "lbl_none"
                      }
                    </h3>
                  </div>
                }

                {
                  <div className="total-price col-12 d-flex justify-content-between pb-2">
                    <h3 className="">
                      {frontLabelsName
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_total"
                        ).length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_total"
                          )[0]["value"] || "lbl_total"
                          : "lbl_total"
                        : "lbl_total"}:
                    </h3>
                    <h3 className="">
                      {detailData?.total} Kr.{" "}
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_per_month")
                          .length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_per_month"
                          )[0]["value"] || "lbl_per_month"
                          : "lbl_per_month"
                        : "lbl_per_month"}
                    </h3>
                  </div>
                }
                {/* end */}

              </div>

              <div className="liability-insurance d-flex justify-content-between align-items-center pb-2">
                <h3 className="">
                  {frontLabelsName
                    ? frontLabelsName.filter((e) => e.key == "lbl_liability_insurance")
                      .length > 0
                      ? frontLabelsName.filter((e) => e.key == "lbl_liability_insurance")[0][
                      "value"
                      ] || "lbl_liability_insurance"
                      : "lbl_liability_insurance"
                    : "lbl_liability_insurance"}:{" "}
                </h3>
                <h3 className="">
            
                  { "Kr." }
                </h3>
              </div>

              {detailData?.fee_type &&
                        detailData?.fee_type.includes("bankGuaranteeOpt") &&  <div className="bankguarantee d-flex justify-content-between pb-1">
                <h3 className="">
                  {frontLabelsName
                    ? frontLabelsName.filter(
                      (e) => e.key == "lbl_bank_guarantee"
                    ).length > 0
                      ? frontLabelsName.filter(
                        (e) => e.key == "lbl_bank_guarantee"
                      )[0]["value"] || "lbl_bank_guarantee"
                      : "lbl_bank_guarantee"
                    : "lbl_bank_guarantee"}:
                </h3>
                <h3 className="">
          
                  {detailData?.securityDeposit ? "Kr." + " " + detailData?.securityDeposit : "N/A"}
                </h3>
              </div> }
              {detailData?.fee_type &&
                        detailData?.fee_type.includes("insuranceFeeOpt") &&   <div className="bankguarantee d-flex justify-content-between pb-1">
                <h3 className="">
                {frontLabelsName
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_insurance_fee_amount"
                        ).length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_insurance_fee_amount"
                          )[0]["value"] || "lbl_insurance_fee_amount"
                          : "lbl_insurance_fee_amount"
                        : "lbl_insurance_fee_amount"}:
                </h3>
                <h3 className="">
          
                  {detailData?.securityDeposit ? "Kr." + " " + detailData?.securityDeposit : "N/A"}
                </h3>
              </div> }
              {detailData?.fee_type &&
                        detailData?.fee_type.includes("rentersInsuranceOpt") &&   <div className="bankguarantee d-flex justify-content-between pb-1">
                <h3 className="">
                {frontLabelsName
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_renters_insurance1"
                        ).length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_renters_insurance1"
                          )[0]["value"] || "lbl_renters_insurance1"
                          : "lbl_renters_insurance1"
                        : "lbl_renters_insurance1"}:
                </h3>
                <h3 className="">
          
                  {detailData?.securityDeposit ? "Kr." + " " + detailData?.securityDeposit : "N/A"}
                </h3>
              </div> }
              {detailData?.fee_type &&
                        detailData?.fee_type.includes("securityDepositOpt") && <div className="bankguarantee d-flex justify-content-between pb-1">
                <h3 className="">
                {frontLabelsName
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_security_deposit"
                        ).length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_security_deposit"
                          )[0]["value"] || "lbl_security_deposit"
                          : "lbl_security_deposit"
                        : "lbl_security_deposit"}:
                </h3>
                <h3 className="">
          
                  {detailData?.securityDeposit ? "Kr." + " " + detailData?.securityDeposit : "N/A"}
                </h3>
              </div> }
           {detailData?.fee_type &&
                        detailData?.fee_type.includes("otherOpt") &&   <div className="bankguarantee d-flex justify-content-between pb-1">
                <h3 className="">
                {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_other")
                          .length > 0
                          ? frontLabelsName.filter((e) => e.key == "lbl_other")[0][
                          "value"
                          ] || "lbl_other"
                          : "lbl_other"
                        : "lbl_other"}:
                </h3>
                <h3 className="">
          
                  {detailData?.securityDeposit ? "Kr." + " " + detailData?.securityDeposit : "N/A"}
                </h3>
              </div> }
             


              <div className="bankguarantee pt-4" style={{ textAlign: "right" }}>
                <button
                  // className="rent-protection"
                  className="btn-app-pro2"
                >
                  {frontLabelsName
                    ? frontLabelsName.filter((e) => e.key == "lbl_rent_protection")
                      .length > 0
                      ? frontLabelsName.filter(
                        (e) => e.key == "lbl_rent_protection"
                      )[0]["value"] || "lbl_rent_protection"
                      : "lbl_rent_protection"
                    : "lbl_rent_protection"}
                </button>
              </div>

              
              <div className="right-menu-bar-fill2 pt-5">
              <div className="first-rent-desc">

                <div className="">
                

              
                  <div className="rental-price d-flex justify-content-between align-items-center">
                    <h3 className="">
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_landlord")
                          .length > 0
                          ? frontLabelsName.filter((e) => e.key == "lbl_landlord")[0][
                          "value"
                          ] || "lbl_landlord"
                          : "lbl_landlord"
                        : "lbl_landlord"}:{" "}
                    </h3>
                    <h3 className="">
                    
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_owner")
                          .length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_owner"
                          )[0]["value"] || "lbl_owner"
                          : "lbl_owner"
                        : "lbl_owner"}:
                     
                    </h3>
                  </div>
                </div>

              </div>

              <div className="desc-pri-set4 pt-3 d-flex flex-row ">
                <div className="col-md-6">
                  <div className="row">
                <div className="col-12 d-flex  pb-0">
                    <h3 className="">
                      {frontLabelsName
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_name"
                        ).length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_name"
                          )[0]["value"] || "lbl_name"
                          : "lbl_name"
                        : "lbl_name"}:
                    </h3>
                    <h3 className="ps-1 fw-500 ">
                  
                      {detailData?.landLord_name
                            ? detailData?.landLord_name : "N/A" }
                  
                    </h3>
                  </div>
                  <div className="col-12 d-flex  pb-0">
                    <h3 className="">
                      {frontLabelsName
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_telephone"
                        ).length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_telephone"
                          )[0]["value"] || "lbl_telephone"
                          : "lbl_telephone"
                        : "lbl_telephone"}:
                    </h3>
                    <h3 className="ps-1 fw-500">
                  
                      {detailData?.landLord_mobile_number
                            ? detailData?.landLord_mobile_number : "N/A" }
                  
                    </h3>
                  </div>
                  <div className="col-12 d-flex  pb-0">
                    <h3 className="">
                    {frontLabelsName
                            ? frontLabelsName.filter((e) => e.key == "lbl_email")
                              .length > 0
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_email"
                              )[0]["value"] || "lbl_email"
                              : "lbl_email"
                            : "lbl_email"}:
                    </h3>
                    <h3 className="ps-1 fw-500">
                  
                      {detailData?.landLord_email
                            ? detailData?.landLord_email : "N/A" }
                  
                    </h3>
                  </div>
                  <div className="col-12 d-flex  pb-0">
                    <h3 className="">
                      {frontLabelsName
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_contact"
                        ).length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_contact"
                          )[0]["value"] || "lbl_contact"
                          : "lbl_contact"
                        : "lbl_contact"}:
                    </h3>
                    <h3 className="ps-1 fw-500">
                  
                    {detailData?.landLord_availability
                            ? getAvailabilityMultilanguage(
                              detailData?.landLord_availability
                            )
                            : detailData?.posted_by?.availableTime?getAvailabilityMultilanguage(
                              detailData?.posted_by?.availableTime
                            ):"N/A"}
                  
                    </h3>
                  </div>
                   </div>
                </div>
                <div className="col-md-6">

                <div className="row">
                <div className="col-12 d-flex justify-content-end  pb-0">
                    <h3 className="">
                      {frontLabelsName
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_name"
                        ).length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_name"
                          )[0]["value"] || "lbl_name"
                          : "lbl_name"
                        : "lbl_name"}:
                    </h3>
                    <h3 className="ps-1 fw-500">
                  
                      {detailData?.posted_by?.full_name
                            ? detailData?.posted_by?.full_name : "N/A" }
                  
                    </h3>
                  </div>
                  </div>

                
                  </div>
          
          

              </div>

          

              
            
                 



            </div>
                 



            </div>
          </div>

         
        </div>

     
        <div className="row row_style mt-4">
          <div className="col-lg-12 col-md-12">
           

      
         <div className="row row_style">
          <div className="col-lg-8 col-md-12">
            <div className="fill-list-main1">
              <div className="row">
                <div className="col-lg-4 col-md-6">
                  <div className="filter-all-main1">
                    <h2>
                    {frontLabelsName
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_facilities_accessories"
                          ).length > 0
                            ? frontLabelsName.filter(
                              (e) => e.key == "lbl_facilities_accessories"
                            )[0]["value"] || "lbl_facilities_accessories"
                            : "lbl_facilities_accessories"
                          : "lbl_facilities_accessories"}
                    </h2>
                 {detailData?.access && detailData?.access.length > 0
                      ? includs(accessType, detailData?.access)
                      : null}

                    {detailData?.access && detailData?.access.length > 0
                      ? includs1(accessType, detailData?.access)
                      : null}
                    {detailData?.access &&
                      detailData?.access.length === 0 &&
                      includs2(accessType)} 
                       {detailData?.other_facilities &&
                      detailData?.other_facilities.length > 0
                      ? includs(otherType, detailData?.other_facilities)
                      : null}

                    {detailData?.other_facilities &&
                      detailData?.other_facilities.length > 0
                      ? includs1(otherType, detailData?.other_facilities)
                      : null}
                    {detailData?.other_facilities &&
                      detailData?.other_facilities.length === 0 &&
                      includs2(otherType)}
                  </div>
                </div>
             
                <div className="col-lg-4 col-md-6">
                  <div className="filter-all-main1">
                    <h2>
                      {frontLabelsName
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_home_appliances"
                        ).length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_home_appliances"
                          )[0]["value"] || "lbl_home_appliances"
                          : "lbl_home_appliances"
                        : "lbl_home_appliances"}
                    </h2>

                    {detailData?.homeAppliances &&
                      detailData?.homeAppliances.length > 0
                      ? includs(homeApplianceType, detailData?.homeAppliances)
                      : null}

                    {detailData?.homeAppliances &&
                      detailData?.homeAppliances.length > 0
                      ? includs1(homeApplianceType, detailData?.homeAppliances)
                      : null}
                    {detailData?.included &&
                      detailData?.homeAppliances.length === 0 &&
                      includs2(homeApplianceType)}
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="filter-all-main1">
                    <h2>
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_restrictions")
                          .length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_restrictions"
                          )[0]["value"] || "lbl_restrictions"
                          : "lbl_restrictions"
                        : "lbl_restrictions"}
                    </h2>

                    {detailData?.restrictions &&
                      detailData?.restrictions.length > 0
                      ? includs(restrictionsType, detailData?.restrictions)
                      : null}

                    {detailData?.restrictions &&
                      detailData?.restrictions.length > 0
                      ? includs1(restrictionsType, detailData?.restrictions)
                      : null}
                    {detailData?.included &&
                      detailData?.restrictions.length === 0 &&
                      includs2(restrictionsType)}
   <div className="setting-links1">
            <p>
             
                <span className="d-flex cus-space1">
                  <img src={detailData?.pets === 1 ? "assets/tick.svg" :"assets/cross.svg"} alt=""/>
                  {frontLabelsName
                            ? frontLabelsName.filter((e) => e.key == "lbl_pets")
                              .length > 0
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_pets"
                              )[0]["value"] || "lbl_pets"
                              : "lbl_pets"
                            : "lbl_pets"}
                </span>
            
            </p>
          </div>
          <div className="setting-links1">
            <p>
             
                <span className="d-flex cus-space1">
                  <img src={detailData?.smoking === 1 ? "assets/tick.svg" :"assets/cross.svg"} alt=""/>
                  {frontLabelsName
                            ? frontLabelsName.filter((e) => e.key == "lbl_smoking")
                              .length > 0
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_smoking"
                              )[0]["value"] || "lbl_smoking"
                              : "lbl_smoking"
                            : "lbl_smoking"}
                </span>
            
            </p>
          </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-12 google-map-col">
            <div className="google-map-code">
          
              {!mapLoading && (
                <MapComponentDetail
                  detailData={detailData}
                  propertyLoading={propertyLoading}
           
                />
              )}

              {mapLoading && <Loading />}
            </div>
          </div>
        </div>
        <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="dsc-bottom-all1 ">
                  <h2>
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_description")
                        .length > 0
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_description"
                        )[0]["value"] || "lbl_description"
                        : "lbl_description"
                      : "lbl_description"}{" "}
                    :
                  </h2>
                  <p className="">{detailData?.description}</p>
                </div>
              </div>
       
            </div>
            <div className="btn-tow-bottom-side d-flex justify-content-between mt-2 pb-2 reported-styles">
              {detailData?.reported === 0 ? (
                // <Link to={`/report-property/${detailData?._id}`}>
                <button
                  className="btn-reportspam1"
                  onClick={(e) => reportdetails(e, detailData?._id)}
                >
                  <span>
                    <img src="assets/report.svg" alt="report" />

                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_report_here")
                        .length > 0
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_report_here"
                        )[0]["value"] || "lbl_report_here"
                        : "lbl_report_here"
                      : "lbl_report_here"}
                  </span>
                </button>
              ) : (
                // </Link>
                <button className="btn-reportspam1 disable-links-button">
                  <span>
                    <img src="assets/report.svg" alt="report" />

                    {frontLabelsName
                      ? frontLabelsName.filter(
                        (e) => e.key == "lbl_already_reported"
                      ).length > 0
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_already_reported"
                        )[0]["value"] || "lbl_already_reported"
                        : "lbl_already_reported"
                      : "lbl_already_reported"}
                  </span>
                </button>
              )}

              {detailData?.applied === 0 ? (
                <button
                  className="btn-app-pro1"
                  // onClick={applyToggle}
                  onClick={() => loginCheck(detailData)}
                  disabled={detailData?.applied === 1}
                >
                  <span>
                    <img src="assets/applyforaproperty.svg" alt="report" />

                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_apply_property")
                        .length > 0
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_apply_property"
                        )[0]["value"] || "lbl_apply_property"
                        : "lbl_apply_property"
                      : "lbl_apply_property"}
                  </span>
                </button>
              ) : (
                <button
                  className="btn-app-pro1 disable-links"
                  onClick={applyToggle}
                  disabled={detailData?.applied === 1}
                >
                  <span>
                    <img src="assets/applied.svg" alt="report" />

                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_already_applied")
                        .length > 0
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_already_applied"
                        )[0]["value"] || "lbl_already_applied"
                        : "lbl_already_applied"
                      : "lbl_already_applied"}
                  </span>
                </button>
              )}
            </div>
    <div className="similar-proprty d-flex justify-content-between">
              <h2>
                <span>
                  <img src="assets/similarproperties.svg" />
                  {frontLabelsName
                    ? frontLabelsName.filter(
                      (e) => e.key == "lbl_similar_properties"
                    ).length > 0
                      ? frontLabelsName.filter(
                        (e) => e.key == "lbl_similar_properties"
                      )[0]["value"] || "lbl_similar_properties"
                      : "lbl_similar_properties"
                    : "lbl_similar_properties"}
                </span>
              </h2>
              <h2>
                <Link to="/properties-list">
                  {frontLabelsName
                    ? frontLabelsName.filter((e) => e.key == "lbl_see_more").length >
                      0
                      ? frontLabelsName.filter((e) => e.key == "lbl_see_more")[0][
                      "value"
                      ] || "lbl_see_more"
                      : "lbl_see_more"
                    : "lbl_see_more"}
                </Link>
              </h2>
            </div>
          <div className="bottom-slider">
              <Slider {...settings}>
                {!propertyLoading && property.docs.length > 0 ? (
                  property.docs.map((list, i) => (
                    <div className="view-card-main2 mt-2" key={i}>
                      <Link to={`/property-details/${list._id}`}>
                        <div className="img-view-main2 ">
                          <img
                            src={
                              list.cover_photo
                                ? list.cover_photo
                                : list.photo_gallery[0]
                            }
                            alt="img1"
                            width="100%"
                            height="300px "
                          />
                        </div>
                        <div className="overlayblack-card1">
                          <div className="set-overlay2">
                            <p style={{lineHeight:1}}>
                              {list.location.length > 30
                                ? list.location.substring(0, 30) + "..."
                                : list.location}
                            </p>
                            <div className="bottom-desc2 d-flex">
                              <p style={{lineHeight:1.2}}>
                                {list.description.length > 80
                                  ? list.description.substring(0, 80) + "..."
                                  : list.description}
                              </p>
                              <span>
                                {list.property_price ||
                                  list.sale_price ||
                                  list.pg_price}
                              </span>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  ))
                ) : (
                  <Loading />
                )}
              </Slider>
            </div>
          </div>
        </div>
      </div>

      {/* apply modal */}
      <Modal
        open={false}
        onClose={handleApplyModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="property-model1"
        disableScrollLock={true}
        keepMounted={true}
      >
        <Box className="modal-content model-box1">
          <Form className="p-4">
            <div className="model-header-custom">
              <div className="desc-md-custom">
                <h2>
                  Are you sure you want to apply for {applyBoxData.location},{" "}
                  {applyBoxData.area} ?
                </h2>
                <div className="d-flex custom-fll2">
                  <button onClick={applyModelProperty}>Yes</button>
                  <button onClick={handleApplyModal}>No</button>
                </div>
              </div>
            </div>
          </Form>
        </Box>
      </Modal>

      {/* new apply property model */}

      <Dialog
        open={openApplyBox}
        onClose={handleApplyModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        alignItems="center"
        className="property-model22"
        sx={{
          p: 3,
          "& .css-1t1j96h-MuiPaper-root-MuiDialog-paper": {
            borderRadius: "15px",
            width: { lg: "494px", md: "400px", sm: "370px", xs: "350px" },
          },
        }}
      >
        {openApplyBox && (
          <>
            <DialogTitle
              id="alert-dialog-title"
              sx={{ fontSize: { xs: 18, sm: 20, md: 22, lg: 26 } }}
            >
              Are you sure you want to apply for <br />
              {applyBoxData.location}, {applyBoxData.area} ?
            </DialogTitle>
            {/* <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  <Typography variant="body2" component="span">
                  Are you sure you want to apply for {applyBoxData.location}, {applyBoxData.area}{" "} ?
                    
                  </Typography>
                </DialogContentText>
              </DialogContent> */}
            <DialogActions
              sx={{ p: 2.5, justifyContent: "center", gap: "10px" }}
              className="active-buttons"
            >
              <button
                className="apply-model-box"
                onClick={applyModelProperty}
              // variant="contained"
              // style={{width:'100%',height:'43px',borderRadius:'0px',border:'none',background:'#F5D792',
              //     color:'#000',boxShadow:'0px 0px 10px #00000040',fontSize: '20px',
              //     fontWeight: '400'}}
              >
                Yes
              </button>

              <button
                onClick={handleApplyModal}
                // autoFocus
                // variant="contained"
                className="apply-model-box"
              // style={{
              //   mr: 2,
              //   pl: 2,
              //   width:'100%',
              //   height:'43px',
              //   borderRadius:'0px',
              //   border:'none',
              //   background:'#F5D792',
              //   color:'#000',
              //   boxShadow:'0px 0px 10px #00000040',fontSize: '20px',
              //   fontWeight: '400'
              // }}
              >
                No
              </button>
            </DialogActions>
          </>
        )}
      </Dialog>

      {/* image slider model */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{ overlay: { background: "black" } }}
      >
        <Box className="model-box">
          <img
            src="assets/cross.svg"
            onClick={handleClose}
            className="cross-img"
          />

          <ImageGallery
            items={imgSlider_Model}
            showFullscreenButton={false}
            showPlayButton={false}
            autoPlay={true}
            onErrorImageURL="assets/no-picture-available-icon-1.jpg"
          />
        </Box>
      </Modal>

      <Suspense fallback={<Loading />}>
        <Footer />
      </Suspense>
    </React.Fragment >
  );
};

const mapStateToProps = (state) => ({
  properties: state.properties,
  auth: state.auth,
  label: state.language,
});

export default connect(mapStateToProps, {
  getPropertyDetail,
  getPropertyDetailOwner,
  getPropertyList,
  applyProperty,
  loadUser,
  likeProperty,
  unlikeProperty,
  hiddenProperty,
  reportProperty,
  addChat,
  PrintPropertyDetail,
  dropdownPropertyField,
})(PropertyPreview);
